import { apiClient } from 'common/clients/api.client';
import { API_ENDPOINTS } from 'common/constants/api-endpoints.constants';
import { EApiPathParams } from 'common/enums/api-path-params.enum';
import {
  TAccountDetailRes,
  TAccountsListReqParams,
  TAccountsListResData,
  TCreateAccountReqParams,
  CreateAccountResData,
  TAccountCustomersResData,
  TCreateCustomerAccountReqParams,
  TCreateCustomerAccountResData,
  TAdminAccountsReqParams,
  TCreateBranchAccountResData,
  TCreateBranchAccountReqParams,
} from '../types/accounts.types';

export const getAdminAccountsListService = async (
  params: TAdminAccountsReqParams = {},
): Promise<TAccountsListResData> => {
  const url = API_ENDPOINTS.ACCOUNTS.ADMIN_ACCOUNTS;
  const config = { params };
  const res = await apiClient.get<TAccountsListResData>(url, config);

  return res?.data || {};
};

export const getCounterpartyAccountsService = async (
  counterpartyGUID: string,
  params: TAccountsListReqParams = {}
): Promise<TAccountsListResData> => {
  const url = API_ENDPOINTS.ACCOUNTS.COUNTERPARTY_ACCOUNTS.replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const config = {
    params,
  };
  if (params.iban?.length === 0) delete config.params.iban;
  if (params.wallet_account_guids?.length === 0 || params.wallet_account_guids?.[0]?.length === 0)
    delete config.params.wallet_account_guids;
  const res = await apiClient.get<TAccountsListResData>(url, config);
  return res.data;
};

export const getCounterpartyAccountDetailsService = async (
  counterpartyGUID: string,
  accountGUID: string,
  params: TAccountsListReqParams = {},
): Promise<TAccountDetailRes> => {
  const url = API_ENDPOINTS.ACCOUNTS.COUNTERPARTY_ACCOUNT_DETAILS
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGUID)
    .replace(EApiPathParams.AccountGuid, accountGUID);
  const config = { params };
  const res = await apiClient.get<TAccountDetailRes>(url, config);

  return res?.data || {};
};

export const getCustomerAccountsDetailsService = async (
  counterpartyGUID: string,
  customerGUID: string,
  params: TAccountsListReqParams = {},
): Promise<TAccountCustomersResData> => {
  const url = API_ENDPOINTS.CUSTOMERS.COUNTERPARTY_CUSTOMER_ACCOUNTS
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGUID)
    .replace(EApiPathParams.CustomerGuid, customerGUID);
  const config = {
    params,
  };
  const res = await apiClient.get<TAccountCustomersResData>(url, config);

  return res.data;
};

export const customerAccountCreateService = async (
  counterpartyGUID: string,
  customerGUID: string,
  iban?: string,
  params: TCreateCustomerAccountReqParams = {},
): Promise<TCreateCustomerAccountResData> => {
  const url = API_ENDPOINTS.CUSTOMERS.COUNTERPARTY_CUSTOMER_ACCOUNTS
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGUID)
    .replace(EApiPathParams.CustomerGuid, customerGUID);
  const config = { params };
  const reqBody: { iban?: string } = {};
  if (iban) reqBody.iban = iban;
  const res = await apiClient.post<TCreateCustomerAccountResData>(url, reqBody, config);

  return res.data;
};

export const createAccountService = async (
  counterpartyGUID: string,
  requestData: TCreateAccountReqParams
): Promise<CreateAccountResData> => {
  const url = API_ENDPOINTS.ACCOUNTS.COUNTERPARTY_ACCOUNTS.replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const res = await apiClient.post<CreateAccountResData>(url, requestData);

  return res.data;
};

export const createBranchAccountService = async (
  counterpartyGUID: string,
  branchGUID: string,
  requestData: TCreateBranchAccountReqParams
): Promise<TCreateBranchAccountResData> => {
  const url = API_ENDPOINTS.ACCOUNTS.COUNTERPARTY_BRANCH_ACCOUNTS
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGUID)
    .replace(EApiPathParams.BranchGuid, branchGUID)
  ;
  const res = await apiClient.post<TCreateBranchAccountResData>(url, requestData);

  return res.data;
};

export const getCounterpartyBranchAccountsService = async (
  counterpartyGUID: string,
  branchGUID: string,
  params: TAccountsListReqParams
): Promise<TAccountsListResData> => {
  const url = API_ENDPOINTS.ACCOUNTS.COUNTERPARTY_BRANCH_ACCOUNTS
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGUID)
    .replace(EApiPathParams.BranchGuid, branchGUID)
  ;
  const config = {
    params,
  };
  const res = await apiClient.get<TAccountsListResData>(url, config);

  return res.data;
};
